import {SERVICE_CHECK_ITEMS} from "../../../utils/constants";

export const generateDefaultFormData = (category: string) => (
  Object.fromEntries(
    SERVICE_CHECK_ITEMS[category].map((itemKey: string) => [itemKey, false])
  )
)